module.exports = "query GetAwardGroups {\n  awardGroups {\n    ...AwardGroupFragment\n  }\n}\n"